 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","admin-admins-form-page":"admin-admins-form-page","admin-admins-page":"admin-admins-page","admin-ads-form-edit-page":"admin-ads-form-edit-page","admin-ads-page":"admin-ads-page","admin-balance-movements-page":"admin-balance-movements-page","admin-balance-movements-regularization-page":"admin-balance-movements-regularization-page","admin-blocks-form-page":"admin-blocks-form-page","admin-blocks-page":"admin-blocks-page","admin-commission-profiles-form-page":"admin-commission-profiles-form-page","admin-commission-profiles-page":"admin-commission-profiles-page","admin-commissions-page":"admin-commissions-page","admin-dashboard-page":"admin-dashboard-page","admin-deposit-account-groups-form-page":"admin-deposit-account-groups-form-page","admin-deposit-account-groups-page":"admin-deposit-account-groups-page","admin-lotteries-closing-schedules-edit-page":"admin-lotteries-closing-schedules-edit-page","admin-lotteries-closing-schedules-page":"admin-lotteries-closing-schedules-page","admin-lotteries-form-page":"admin-lotteries-form-page","admin-lotteries-page":"admin-lotteries-page","admin-orders-page":"admin-orders-page","admin-orders-view-page":"admin-orders-view-page","admin-page":"admin-page","admin-password-reset-page":"admin-password-reset-page","admin-password-reset-verification-page":"admin-password-reset-verification-page","admin-promotion-raffles-form-page":"admin-promotion-raffles-form-page","admin-promotion-raffles-page":"admin-promotion-raffles-page","admin-promotions-form-page":"admin-promotions-form-page","admin-promotions-page":"admin-promotions-page","admin-raffles-form-page":"admin-raffles-form-page","admin-raffles-page":"admin-raffles-page","admin-reports-monitoring-page":"admin-reports-monitoring-page","admin-scheduled-promotion-raffles-form-page":"admin-scheduled-promotion-raffles-form-page","admin-scheduled-promotion-raffles-page":"admin-scheduled-promotion-raffles-page","admin-system-config-page":"admin-system-config-page","admin-transaction-profiles-form-page":"admin-transaction-profiles-form-page","admin-transaction-profiles-page":"admin-transaction-profiles-page","admin-transaction-view-page~admin-transactions-page~admin-users-form-page":"admin-transaction-view-page~admin-transactions-page~admin-users-form-page","admin-transaction-view-page":"admin-transaction-view-page","admin-transactions-page":"admin-transactions-page","admin-users-form-page":"admin-users-form-page","admin-users-identity-verifications-page":"admin-users-identity-verifications-page","admin-users-identity-verifications-view-page":"admin-users-identity-verifications-view-page","admin-users-page":"admin-users-page","admin-working-hours-form-page~admin-working-hours-page~buy-page~home~promotions-page~register~result~346ffc40":"admin-working-hours-form-page~admin-working-hours-page~buy-page~home~promotions-page~register~result~346ffc40","admin-working-hours-form-page":"admin-working-hours-form-page","admin-working-hours-page":"admin-working-hours-page","bankaccount-page~transaction-request-page":"bankaccount-page~transaction-request-page","transaction-request-page":"transaction-request-page","buy-page~home":"buy-page~home","buy-page":"buy-page","home~live-lottery~roulettes~ticket-list-page~welcome":"home~live-lottery~roulettes~ticket-list-page~welcome","home":"home","login~register":"login~register","register":"register","promotions-page":"promotions-page","results":"results","balance-movements-page":"balance-movements-page","bankaccount-page":"bankaccount-page","cash-balance-report-page":"cash-balance-report-page","change-password-page":"change-password-page","faqs":"faqs","live-lottery":"live-lottery","roulettes":"roulettes","ticket-list-page":"ticket-list-page","welcome":"welcome","how-to-play":"how-to-play","login":"login","notifications-page":"notifications-page","password-reset-page":"password-reset-page","password-reset-verification-page":"password-reset-verification-page","privacy-policies-page":"privacy-policies-page","problem-report":"problem-report","profile-change-password-page":"profile-change-password-page","profile-page":"profile-page","profile-verify-phone-page":"profile-verify-phone-page","referrals-page":"referrals-page","responsible-gaming-page":"responsible-gaming-page","terms-and-conditions-page":"terms-and-conditions-page","ticket-view-page":"ticket-view-page","transaction-list-page":"transaction-list-page","transaction-view-page":"transaction-view-page","verify-account-page":"verify-account-page","verify-identity-page":"verify-identity-page","verifyphone-page":"verifyphone-page"}[chunkId]||chunkId) + "." + "6459fbc617605102" + ".js?v=1.0.0"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"404":1,"admin-admins-form-page":1,"admin-admins-page":1,"admin-ads-form-edit-page":1,"admin-ads-page":1,"admin-balance-movements-page":1,"admin-balance-movements-regularization-page":1,"admin-blocks-form-page":1,"admin-blocks-page":1,"admin-commission-profiles-form-page":1,"admin-commission-profiles-page":1,"admin-commissions-page":1,"admin-deposit-account-groups-form-page":1,"admin-deposit-account-groups-page":1,"admin-lotteries-closing-schedules-edit-page":1,"admin-lotteries-closing-schedules-page":1,"admin-lotteries-form-page":1,"admin-lotteries-page":1,"admin-orders-page":1,"admin-orders-view-page":1,"admin-page":1,"admin-password-reset-page":1,"admin-password-reset-verification-page":1,"admin-promotion-raffles-form-page":1,"admin-promotion-raffles-page":1,"admin-promotions-form-page":1,"admin-promotions-page":1,"admin-raffles-form-page":1,"admin-raffles-page":1,"admin-reports-monitoring-page":1,"admin-scheduled-promotion-raffles-form-page":1,"admin-scheduled-promotion-raffles-page":1,"admin-system-config-page":1,"admin-transaction-profiles-form-page":1,"admin-transaction-profiles-page":1,"admin-transaction-view-page~admin-transactions-page~admin-users-form-page":1,"admin-transaction-view-page":1,"admin-transactions-page":1,"admin-users-form-page":1,"admin-users-identity-verifications-page":1,"admin-users-identity-verifications-view-page":1,"admin-users-page":1,"admin-working-hours-form-page":1,"admin-working-hours-page":1,"bankaccount-page~transaction-request-page":1,"transaction-request-page":1,"buy-page~home":1,"buy-page":1,"home":1,"login~register":1,"register":1,"promotions-page":1,"results":1,"balance-movements-page":1,"bankaccount-page":1,"cash-balance-report-page":1,"change-password-page":1,"faqs":1,"live-lottery":1,"roulettes":1,"ticket-list-page":1,"welcome":1,"how-to-play":1,"login":1,"notifications-page":1,"password-reset-page":1,"password-reset-verification-page":1,"privacy-policies-page":1,"problem-report":1,"profile-change-password-page":1,"profile-page":1,"profile-verify-phone-page":1,"referrals-page":1,"responsible-gaming-page":1,"terms-and-conditions-page":1,"ticket-view-page":1,"transaction-list-page":1,"transaction-view-page":1,"verify-account-page":1,"verify-identity-page":1,"verifyphone-page":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","admin-admins-form-page":"admin-admins-form-page","admin-admins-page":"admin-admins-page","admin-ads-form-edit-page":"admin-ads-form-edit-page","admin-ads-page":"admin-ads-page","admin-balance-movements-page":"admin-balance-movements-page","admin-balance-movements-regularization-page":"admin-balance-movements-regularization-page","admin-blocks-form-page":"admin-blocks-form-page","admin-blocks-page":"admin-blocks-page","admin-commission-profiles-form-page":"admin-commission-profiles-form-page","admin-commission-profiles-page":"admin-commission-profiles-page","admin-commissions-page":"admin-commissions-page","admin-dashboard-page":"admin-dashboard-page","admin-deposit-account-groups-form-page":"admin-deposit-account-groups-form-page","admin-deposit-account-groups-page":"admin-deposit-account-groups-page","admin-lotteries-closing-schedules-edit-page":"admin-lotteries-closing-schedules-edit-page","admin-lotteries-closing-schedules-page":"admin-lotteries-closing-schedules-page","admin-lotteries-form-page":"admin-lotteries-form-page","admin-lotteries-page":"admin-lotteries-page","admin-orders-page":"admin-orders-page","admin-orders-view-page":"admin-orders-view-page","admin-page":"admin-page","admin-password-reset-page":"admin-password-reset-page","admin-password-reset-verification-page":"admin-password-reset-verification-page","admin-promotion-raffles-form-page":"admin-promotion-raffles-form-page","admin-promotion-raffles-page":"admin-promotion-raffles-page","admin-promotions-form-page":"admin-promotions-form-page","admin-promotions-page":"admin-promotions-page","admin-raffles-form-page":"admin-raffles-form-page","admin-raffles-page":"admin-raffles-page","admin-reports-monitoring-page":"admin-reports-monitoring-page","admin-scheduled-promotion-raffles-form-page":"admin-scheduled-promotion-raffles-form-page","admin-scheduled-promotion-raffles-page":"admin-scheduled-promotion-raffles-page","admin-system-config-page":"admin-system-config-page","admin-transaction-profiles-form-page":"admin-transaction-profiles-form-page","admin-transaction-profiles-page":"admin-transaction-profiles-page","admin-transaction-view-page~admin-transactions-page~admin-users-form-page":"admin-transaction-view-page~admin-transactions-page~admin-users-form-page","admin-transaction-view-page":"admin-transaction-view-page","admin-transactions-page":"admin-transactions-page","admin-users-form-page":"admin-users-form-page","admin-users-identity-verifications-page":"admin-users-identity-verifications-page","admin-users-identity-verifications-view-page":"admin-users-identity-verifications-view-page","admin-users-page":"admin-users-page","admin-working-hours-form-page~admin-working-hours-page~buy-page~home~promotions-page~register~result~346ffc40":"admin-working-hours-form-page~admin-working-hours-page~buy-page~home~promotions-page~register~result~346ffc40","admin-working-hours-form-page":"admin-working-hours-form-page","admin-working-hours-page":"admin-working-hours-page","bankaccount-page~transaction-request-page":"bankaccount-page~transaction-request-page","transaction-request-page":"transaction-request-page","buy-page~home":"buy-page~home","buy-page":"buy-page","home~live-lottery~roulettes~ticket-list-page~welcome":"home~live-lottery~roulettes~ticket-list-page~welcome","home":"home","login~register":"login~register","register":"register","promotions-page":"promotions-page","results":"results","balance-movements-page":"balance-movements-page","bankaccount-page":"bankaccount-page","cash-balance-report-page":"cash-balance-report-page","change-password-page":"change-password-page","faqs":"faqs","live-lottery":"live-lottery","roulettes":"roulettes","ticket-list-page":"ticket-list-page","welcome":"welcome","how-to-play":"how-to-play","login":"login","notifications-page":"notifications-page","password-reset-page":"password-reset-page","password-reset-verification-page":"password-reset-verification-page","privacy-policies-page":"privacy-policies-page","problem-report":"problem-report","profile-change-password-page":"profile-change-password-page","profile-page":"profile-page","profile-verify-phone-page":"profile-verify-phone-page","referrals-page":"referrals-page","responsible-gaming-page":"responsible-gaming-page","terms-and-conditions-page":"terms-and-conditions-page","ticket-view-page":"ticket-view-page","transaction-list-page":"transaction-list-page","transaction-view-page":"transaction-view-page","verify-account-page":"verify-account-page","verify-identity-page":"verify-identity-page","verifyphone-page":"verifyphone-page"}[chunkId]||chunkId) + "." + "6459fbc617605102" + ".css?v=1.0.0";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
